import { z } from "zod"
import Environment from "../../domain/Environment.js"
import LocaleCode from "../../domain/LocaleCode.js"
import Region from "../../domain/Region.js"
import { AWSRegionSchema } from "../shared/AWSRegion.js"
import { EnvironmentSchema } from "../shared/Environment.js"
import { LocaleCodeSchema } from "../shared/LocaleSchema.js"
import { URISchema } from "../shared/URI.js"

/**
 * @description
 *	The environment configuration schema.
 */
export const EnvironmentConfigurationSchema = z
	.object({
		AWS_REGION: AWSRegionSchema.default(Region.USEast_NorthVirginia),
		BIOMETRY_ORIGIN: URISchema.default("https://biometry.api.local.sanii.la:8443"),
		DEFAULT_LOCALE: LocaleCodeSchema.default(LocaleCode.es_AR),
		ENVIRONMENT: EnvironmentSchema.default(Environment.Local),
		HTTP_CLIENT_TIMEOUT_IN_MILLISECONDS: z.coerce
			.number()
			.int()
			.min(5000)
			.default(60 * 1000)
	})
	.readonly()

export type EnvironmentConfiguration = z.infer<typeof EnvironmentConfigurationSchema>
